@import "../../utils/error-message.css";

:host {
  font-family: var(--ls-font-family);
  position: relative;
  display: block;
  width: 100%;
  min-height: 200px;
  overflow: hidden;
}

.container {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: inherit;
}

.has-error .chart-container {
  pointer-events: none;
}

.chart-container {
  display: flex;
  width: 100%;
  position: relative;
}

.y-axis-container {
  flex-shrink: 0;
  width: 20px;
  position: relative;
  z-index: 2;
}

.chart-scroll-container {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  position: relative;
}

.chart {
  min-width: 800px;
}

.path {
  fill: none;
  stroke: var(--ls-primary-color);
  stroke-width: 3px;
}

.line {
  stroke: var(--ls-gray-300);
  stroke-width: 1;
  shape-rendering: crispEdges;
}

.line:first-child {
  stroke: var(--ls-gray-500);
}

.stop {
  fill: var(--ls-primary-color);
  stroke: none;
}

.fake {
  fill: transparent;
  stroke: none;
}

.passed {
  fill: var(--ls-gray-50);
  stroke: var(--ls-primary-color);
  stroke-width: 1px;
}

.overlay {
  fill: none;
  stroke: none;
  pointer-events: all;
}

.loading {
  font-size: var(--ls-text-base);
  line-height: var(--ls-line-base);
  font-family: var(--ls-font-family);
  color: var(--ls-font-primary-color);
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-items: center;
}

.focusLine {
  fill: none;
  stroke: var(--ls-accent-color);
  stroke-width: 1px;
}

.focusCircle {
  fill: var(--ls-accent-color);
}

.focus_text_container rect {
  fill: rgba(0, 0, 0, 0.1);
}

.focus_text_container text {
  fill: var(--ls-font-primary-color);
  font-family: var(--ls-font-family);
}

.axis {
  font-family: var(--ls-font-family);
}

.axis path,
.axis line {
  fill: none;
  stroke: var(--ls-gray-500);
  stroke-width: 1;
  shape-rendering: crispEdges;
}
